const GalleryData =
[
    {
      "id": 1,
      "src": require("./gallery/navana Group.jpg"),
      "tag": ""
    },
    {
      "id": 1,
      "src": require("./gallery/navana spint.jpg"),
      "tag": ""
    },
    {
      "id": 2,
      "src": require("./gallery/VC of Navana With Tanjim.jpg"),
      "tag": ""
    },
    {
      "id": 2,
      "src": require("./gallery/Bashonto pic Tanjim Navana Group (3).jpg"),
      "tag": ""
    },
    {
      "id": 2,
      "src": require("./gallery/navana soft.jpeg"),
      "tag": ""
    },
  {
    "id": 1, 
    "src": require("./gallery/img.jpg"),
    "tag": ""
  },
  {
    "id": 2,
    "src": require("./gallery/img2.jpeg"),
    "tag": ""
  },
  {
    "id": 2,
    "src": require("./gallery/img1.jpg"),
    "tag": ""
  },
  {
    "id": 2,
    "src": require("./gallery/dominno5.jpg"),
    "tag": ""
  },
  
  {
    "id": 3,
    "src": require("./gallery/dominno md with tanjim.jpeg"),
    "tag": ""
  }
  
]

export default GalleryData